import React, { Component } from "react";
import StatsBox from "../StatsPage/StatsBox.js";
import InfoTable from "../InfoTable.js";
import ResultInfoText from "../ResultsTable/ResultInfoText.js";
import KingdomIcon from "../ReactionTable/kingdomIcon.js";
import { useState } from "react";
import axios from "../../api/axios.js";
import { useEffect } from "react";
import getDataByEnzymesFromSearchResults from "../../api/transformSearchResultsToEnzymes.js";
import { useParams } from "react-router-dom";
import ReactionResultBox from "../ResultsTable/ReactionResultBox.js";
import translateTerpeneType from "../../api/typeTranslator.js";
import SmallLoading from "../smallLoading.js";
import MoleculesDiv from "../MoleculeTable/MoleculesDiv.js";
import { getUniqueMoleculesFromEnzymesAllInfo } from "../../api/HelperFunctions.js";
import { groupTypesAndKingdoms } from "../../functions/statisticsDataProcessing.js";
import SubmitInputField from "../SubmitPage/submitInputField.js";



function MoleculeBrowser({ setMechBody, navigateToRecord}) {
    const [stats, setStats] = useState(null);
    const [kingdoms, setKingdoms] = useState([]);
    const [selectedTypes, setSelectedTypes] = useState([]);
    const [selectedClasses, setSelectedClasses] = useState([]);
    const [selectedKingdoms, setSelectedKingdoms] = useState([]);
    const [selectedSpecies, setSelectedSpecies] = useState([]);
    const [selectedMolName, setSelectedMolName] = useState("");
    const [searchData, setSearchData] = useState({ types: [], kingdoms: [], mol_names: []});
    const [molecules, setMolecules] = useState([]);

    const [loading, setLoading] = useState(false);

    const handleNameChange = (e) => {
        const value = e.target.value;
        setSelectedMolName(value);
    }

    
    function processStats(stats){
    let kingdomsNames = stats.kingdomsCounts.map(k => k.kingdom);
    const typesAndKingdoms = groupTypesAndKingdoms(stats.terpeneTypesByKingdomCount);
    stats.groupedTypesKingdoms = typesAndKingdoms[0];
    setKingdoms(kingdomsNames.sort());
    return stats;
  }

     useEffect(() => {
        if(stats){
            return;
        }
        console.log("MoleculeBrowser useEffect");
        axios.post("/statspage").then(res => {
          setStats(processStats(res.data));
        });
        handleSearch();
      }, []);


    const toggleSelection = (value, selectedValues, setSelectedValues) => {
    if (selectedValues.includes(value)) {
      setSelectedValues(selectedValues.filter(v => v !== value));
    } else {
      setSelectedValues([...selectedValues, value]);
    }
  };

  async function handleSearch() {
    setLoading(true);
    const res = await axios.post("/basicsearch", {
      types: selectedTypes,
      kingdoms: selectedKingdoms,
      mol_names: selectedMolName ? [selectedMolName] : [],
    });
    console.log("MoleculeBrowser handleSearch res", res.data);
    const reactionsData = getDataByEnzymesFromSearchResults(res.data);
    setMolecules(getUniqueMoleculesFromEnzymesAllInfo(reactionsData).molecules);
    setLoading(false);
  }



     if (!stats){
        return <StatsBox title="Loading molecules..."><SmallLoading /></StatsBox>;
    }
    return (
        <>

        <StatsBox title="Molecule filters" hide={true}>
          <StatsBox title="Terpene types">
            <div className="checkboxes-div">
            {stats.terpenesByType.map(t => (
              <label key={t.type} className="basic-checkbox">
                <input
                  type="checkbox"
                  className="basic-checkbox-box"
                  checked={selectedTypes.includes(t.type)}
                  onChange={() => toggleSelection(t.type, selectedTypes, setSelectedTypes)}
                />
                <span >{translateTerpeneType(t.type)}</span>
              </label>          
            ))}
            </div>
          </StatsBox>

          <StatsBox title="Origin kingdoms">
            <div className="checkboxes-div">
            {kingdoms.map(k => (
              <label key={k} className="basic-checkbox">
                <input
                  type="checkbox"
                  className="basic-checkbox-box"
                  checked={selectedKingdoms.includes(k)}
                  onChange={() => toggleSelection(k, selectedKingdoms, setSelectedKingdoms)}
                />
                <span>{k}</span>
              </label>
            ))}
           </div> 
          </StatsBox>
          <StatsBox title="Molecule name">
            <div>
              <SubmitInputField name="nameMol" value={selectedMolName} onChange={handleNameChange} label="Molecule name" disabled={false} tooltip={"Enter part of the desired molecule name"} placeholder="germacrene"/>
            </div>

          </StatsBox>
          <button
            className="basic-button"
            onClick={() => handleSearch()}
          >
            Display selected
          </button>
        </StatsBox>


        <StatsBox title={"Products and substrates"}>
            { loading ? <SmallLoading /> : <>
            <div style={{ display: "flex", justifyContent: "center" }}>Found {molecules.length} molecules</div>
            <MoleculesDiv molecules={molecules} startingDisplay={18} displayStep={18} /></>
            }
        </StatsBox>
    
        </ >
    );

}

export default MoleculeBrowser;